import React from 'react';
import { Box, Center, Flex, SimpleGrid, Text } from '@chakra-ui/react';
import 'yet-another-react-lightbox/styles.css';
import 'yet-another-react-lightbox/plugins/thumbnails.css';
import dynamic from 'next/dynamic';
import Thumbnails from 'yet-another-react-lightbox/plugins/thumbnails';
import LightboxRender from './ImageGalleryRender';
import HoverOverlay from './HoverOverlay';
import {
  ProjectGalleryFragment,
  SanityCustomImageFragment,
} from '@src/generated/graphql';
import SanityImage from '@components/Shared/SanityImage';

const Lightbox = dynamic(() => import('yet-another-react-lightbox'));

const ImageGallery: React.FC<ProjectGalleryFragment> = ({ images }) => {
  const [open, setOpen] = React.useState(false);
  const [selectedImages, setSelectedImages] = React.useState<
    SanityCustomImageFragment[]
  >([]);

  const onImageClick = (i: number) => {
    const selected = images?.[i]?.images;
    if (!selected) return;
    setSelectedImages(selected as SanityCustomImageFragment[]);
    setOpen(true);
  };

  if (!images) return null;
  return (
    <Center w="100%">
      <SimpleGrid
        columns={[1, null, 3]}
        spacing={30}
        maxW={1188}
        w="100%"
        p="40px"
      >
        {images?.map((image, i) => (
          <Flex
            direction="column"
            alignItems="center"
            key={image?.title}
            _hover={{ cursor: 'pointer', '.overlay': { opacity: 0.7 } }}
          >
            <Box pos="relative" w="100%">
              <SanityImage
                sanityImage={image?.thumbnail}
                width={350}
                height={200}
                layout="responsive"
              />
              <HoverOverlay index={i} onClick={onImageClick} />
            </Box>
            <Center>
              <Text
                fontSize="md"
                fontFamily="montserrat"
                py="7px"
                color="grey.600"
                textAlign="center"
              >
                {image?.title}
              </Text>
            </Center>
          </Flex>
        ))}
      </SimpleGrid>
      <Lightbox
        open={open}
        close={() => setOpen(false)}
        slides={selectedImages?.map((image) => ({
          src: image?.asset?.url ?? '',
          height: image?.asset?.metadata?.dimensions?.height ?? 0,
          width: image?.asset?.metadata?.dimensions?.width ?? 0,
          alt: image?.alt ?? '',
          blurDataURL: image?.asset?.metadata?.lqip ?? '',
        }))}
        render={{ slide: LightboxRender }}
        plugins={[Thumbnails]}
      />
    </Center>
  );
};

export default ImageGallery;
